import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Layout from './layouts/Default.vue'
import Report from './views/Report/index.vue'
import Login from './views/Login.vue'
// import Service from './views/ServiceRequest.vue'
import store from './store'
import Planmaster from './views/Report/Planmaster.vue'
import Channelmaster from './views/Report/Channelmaster.vue'
import Planmasterlist from './views/Report/Planmasterlist.vue'
import Channelmasterlist from './views/Report/Channelmasterlist.vue'
import Updateuserid from './views/Report/Updateuserid.vue'
import CancelRegistration from './views/Report/CancelRegistration.vue'
import Walletupdate from './views/Report/Walletupdate.vue'
import OSDMessage from './views/Report/Osdmessage.vue'
import Planchannelmapping from './views/Report/Planchannelmapping.vue'
import ReprocessPayment from './views/ReprocessPayment.vue'
// import Quickpay from './views/Quickpay.vue'

import {
  fetchAdd,
  fetchRenew,
  fetchPayments,
  fetchUsers,
  fetchServiceRequests,
  fetchQuickpay,
} from './services/report'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      beforeEnter: (to, from, next) => {
        const { path } = to;
        if (path === '/register') {
          next({
            name: 'Register'
          });
        }
        const cachedUser = localStorage.getItem('in:admin');
        const { userName, token } = store.state.auth;
        const isLoggedIn = userName && token;
        // console.log('is logged in : ', isLoggedIn);
        if (isLoggedIn)
          next();
        else {
          if (cachedUser) {
            // console.log('cached : ', cachedUser);
            const user = JSON.parse(cachedUser);
            const cachedLogin = user.userName && user.token;
            if (cachedLogin) {
              store.dispatch('auth/allowAccess', user);
              next()
            }
          }
          else {
            next({
              name: 'Login'
            })
          }
        }
      },
      children: [
        {
          path: '/(home)*',
          component: Home,
          name: 'Home'
        },
        {
          path: '/Planmaster',
          component: Planmaster,
          name: 'Planmaster'
        },
        {
          path: '/Planmasterlist',
          component: Planmasterlist,
          name: 'Planmasterlist'
        },
        {
          path: '/channelmaster',
          component: Channelmaster,
          name: 'Channelmaster'
        },
        {
          path: '/updateuserid',
          component: Updateuserid,
          name: 'Updateuserid'
        },
        {
          path: '/CancelRegistration',
          component: CancelRegistration,
          name: 'CancelRegistration'
        },
        {
          path: '/ReprocessPayment',
          component: ReprocessPayment,
          name: 'ReprocessPayment'
        },
        {
          path: '/Walletupdate',
          component: Walletupdate,
          name: 'Walletupdate'
        },
        {
          path: '/OSDMessage',
          component: OSDMessage,
          name: 'OSDMessage'
        },
        {
          path: '/Channelmasterlist',
          component: Channelmasterlist,
          name: 'Channelmasterlist'
        },
        {
          path: '/Planchannelmapping',
          component: Planchannelmapping,
          name: 'Planchannelmapping'
        },
        {
          path: '/report/activation',
          component: Report,
          name: 'ActivationReport',
          props: {
            remoteService: fetchAdd,
            context: 'add',
          },
        },
        {
          path: '/report/renewal',
          component: Report,
          name: 'RenewReport',
          props: {
            remoteService: fetchRenew,
            context: 'renew',
          },
        },
        {
          path: '/report/payments',
          component: Report,
          name: 'PaymentReport',
          props: {
            remoteService: fetchPayments,
            context: 'payments',
          },
        },
        {
          path: '/report/payment/quickpay',
          component: Report,
          name: 'QuickpayReport',
          props: {
            remoteService: fetchQuickpay,
            context: 'quickpay',
          },
        },
        {
          path: '/report/registration',
          component: Report,
          name: 'UserReport',
          props: {
            remoteService: fetchUsers,
            context: 'users',
            noUserFilter: true,
          },
        },
        {
          path: '/report/service',
          component: Report,
          name: 'ServiceRequestReport',
          props: {
            remoteService: fetchServiceRequests,
            context: 'serviceRequests',
            noUserFilter: true,
          }
        },

      ]
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
  ]
})
